import { LOCAL_STORE_JWT } from "~/utils/main";

const getAuthHeader = () => {
  const token = localStorage.getItem(LOCAL_STORE_JWT) || false;
  // console.log("getAuthHeader token:", token);

  return {
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  };
};

export { getAuthHeader };
